<template>
  <svg
    :id="btnUid"
    ref="evtbtn"
    @mouseover="mover"
    @mouseleave="mleave"
    @mousedown="mdown"
    @mouseup="mup"
    @touchstart="tstart"
    @touchmove="tmove"
    @touchcancel="tcancel"
    @touchend="tend"
    @click="fireEvent"
    xmlns="http://www.w3.org/2000/svg"
    :width="width"
    :height="height"
    :viewBox="viewbox"
    :aria-labelledby="iconName"
    role="presentation"
    preserveAspectRatio="xMidYMid meet"
    class="unselectable use-pointer"
  >
    <title :id="iconName" lang="jp">{{iconName}}</title>
    <g
      id="Page-1"
      stroke="none"
      stroke-width="1"
      fill="none"
      fill-rule="evenodd"
     >
      <g id="SVGBAuthor">
        <rect
          id="Rectangle-2-Copy"
          x="0"
          y="0"
          rx="12"
          class="backBoxSize"
          :fill="backColor"
        ></rect>
        <g
          :id="iconUid"
          ref="evticon"
          vector-effect="non-scaling-stroke"
          pointer-events="none"
          :transform="ctransform"
          :color="svgColor"
          @touchstart="igtstart"
        >
          <slot></slot>
        </g>
        <rect
          id="Rectangle-2"
          :stroke="frameColor"
          stroke-width="4"
          x="2"
          y="2"
          class="frameBoxSize"
          rx="12"
        ></rect>
        <template v-if="sign == 'leader'">
          <g id="Group" :transform="signPoint" :fill="frameColor">
            <circle id="O1" cx="1" cy="1" r="1"></circle>
            <circle id="O2" cx="4" cy="1" r="1"></circle>
            <circle id="O3" cx="7" cy="1" r="1"></circle>
          </g>
        </template>
        <polygon
          v-else-if="sign != 'none'"
          id="Triangle"
          :fill="frameColor"
          :points="signPoint"
        ></polygon>
      </g>
    </g>
  </svg>
</template>

<script>
  import { mapState } from 'vuex'
  let debugOut = false
  export default {
  props: {
    iconName: {
      type: String,
      default: "box"
    },
    width: {
      type: [Number, String],
      default: 80
    },
    height: {
      type: [Number, String],
      default: 40
    },
    iconWidth: {
      type: [Number, String],
      default: null
    },
    iconHeight: {
      type: [Number, String],
      default: null
    },
    sign: {
      type: String,
      default: "leader" // leader ...   / popup ▲   / pulldown ▼   / none
    },
    contentszoom: {
      type: String,
      default: null
    },
    iconColor: {
      type: String,
      default: null
    },
	frameStyle: {
	  type: String,
	  default: 'normal'
	},
    pushColor: {
      type: String,
      default: null
    },
    disableWhenMount: {
      type: Boolean,
      default: false,
    },
  },
  beforeMount() {
  },
  beforeDestroy() {
  },
  created() {
    debugOut = this.$root.$options.debugOut
    this.timerID = null
  },
  mounted() {
    if (debugOut) {console.log('mounted!')}
    this.isDisable = this.disableWhenMount
    this.$nextTick(() => {
      this.adjustBounds()
      // if (!this.adjustBounds()) {
      //   if (this.timerID !== null) {return}
      //   this.timerID = setInterval(() => {
      //     if (!this.adjustBounds()) {return}
      //     clearInterval(this.timerID)
      //     this.timerID = null
      //   },500)
      // }
      if (debugOut) {console.log(`mounted: px ${this.pxWidth}x${this.pxHeight} / icon ${this.iWidth}x${this.iHeight} '${this.btnUid}'`)}
    })
    this.leaveColor()
    this.svgContentsColor = this.iconColor != null ? this.iconColor : this.defUIIconColor
    if (this.isDisable) {
      this.changeDisable(true)
    }
    this.supportTouch = 'ontouchend' in document
  },
  computed: {
    // pxWidth() {
    //   if (debugOut) {console.log(`pxWidth init ${document.getElementById('svgbtn')}`)}
    //   let pw = document.getElementById('svgbtn').clientWidth
    //   let x = this.toPX(this.width,pw)
    //   if (debugOut) {console.log(`pxWidth: ${x}`)}
    //   return x
    // },
    // pxHight() {
    //   let ph = document.getElementById('svgbtn').clientHeight
    //   let y = this.toPX(this.height,ph)
    //   if (debugOut) {console.log(`pxWidth: ${y}`)}
    //   return y
    // },
    btnUid() {
      return `svgbtn-${this.$_uid}`
    },
    iconUid() {
      return `icon-${this.$_uid}`
    },
    viewbox() {
      // return [0, 0, this.pxWidth, this.pxHeight].join(" ")
      if (debugOut) {console.log('viewbox change!')}
      return `0 0 ${this.pxWidth} ${this.pxHeight}`
    },
    cwidth() {
      return (this.iWidth != null) ? this.iWidth : this.pxWidth
    },
    cheight() {
      return (this.iHeight!= null) ? this.iHeight : this.pxHeight
    },
    cleft() {
      return (this.pxWidth - this.cwidth) / 2
      // return this.pxWidth / 2 - this.cwidth
    },
    ctop() {
      return (this.pxHeight - this.cheight) / 2
      // return this.pxHeight / 2 - this.cheight
    },
    cbox() {
      // return [0, 0, this.cwidth, this.cheight].join(" ")
      return `0 0 ${this.cwidth} ${this.cheight}`
    },
    ctransform() {
      if (this.contentszoom != "use") {
        return this.contentszoom == "none"
          ? "translate(0,0)"
          : `translate(${this.cleft},${this.ctop})`
      } else {
        let hratio = this.pxWidth / this.cwidth
        let vratio = this.pxHeight / this.cheight
        let ratio = hratio < vratio ? hratio : vratio
        let nleft = (this.pxWidth - this.cwidth * ratio) / 2
        let ntop = (this.pxHeight - this.cheight * ratio) / 2
        let trans =
          nleft == 0 && ntop == 0 ? "" : `translate(${nleft},${ntop})`
        return `${trans}scale(${ratio},${ratio})`
      }
    },
    signPoint() {
      let x = this.pxWidth - 14 // 80 - 14 = 66
      let y = this.pxHeight - 14 // 40 - 14 = 26
      switch (this.sign) {
        case "none":
          return ""
        case "leader":
          return `translate(${x - 4}, ${y + 2})`
        case "popup":
          return [x, y, x + 5, y + 6, x - 5, y + 6].join(" ")
        case "pulldown":
          return [x, y + 6, x + 5, y, x - 5, y].join(" ")
        default:
          this.sign = "none"
          return ""
      }
    },
    svgColor() {
      if (!this.iconSizeGet) { return `rgba(255,255,255,0)`}
      return this.isDisable ? this.defUIIconDisColor : this.svgContentsColor
    },
    uiPushColor () {
      return this.pushColor ? this.pushColor : this.defUIBackPushColor
    },
    ...mapState([
        'documentAreaWidth',
        'documentAreaHeight',
        'documentAreaWatcher',
    ]),
  },
  data() {
    return {
      isDisable: false,
      frameColor() {
        return this.defUIFrameColor
      },
      backColor() {
        return this.defUIBackColor
      },
      svgContentsColor() {
        return this.defUIIconColor
      },
      pxWidth: 0,
      pxHeight: 0,
      iWidth: null,
      iHeight: null,
      iconSizeGet: false,
    }
  },
  watch: {
    isDisable(nv, ov) {
      this.changeDisable(nv)
    },
    // documentAreaWatcher(nv) {
    //   if (debugOut) {console.log('catch change document size-- svg button')}
    //   this.$nextTick(() => {
    //     if (this.timerID !== null) return
    //     if(debugOut) {console.log('adjust bounds interval set')}
    //     this.timerID = setInterval(() => {
    //       if (!this.adjustBounds()) {return}
    //       clearInterval(this.timerID)
    //       this.timerID = null
    //       this.$emit('adjustBounds')
    //       if(debugOut) {console.log('adjust bounds interval clear')}
    //     },1000)
    //   })
    // },
  },
  methods: {
    adjustBounds(iconOnly) {
      // let btn = this.$el
      if (iconOnly != true) {
        let btn = document.getElementById(this.btnUid)
        if (!btn) {
          return false
        }
        let w = btn.clientWidth, h = btn.clientHeight
        if ((!w) || (!h)) {
          return false
        }
        if ((this.pxWidth === w) && (this.pxHeight === h)) {
          return false
        }
        this.pxWidth = w
        this.pxHeight = h
      }
      // let icon = document.getElementById(this.iconUid)
      let icon = this.$refs.evticon
      let iconRect = icon.getBoundingClientRect()
      this.iWidth = (this.iconWidth != null) ? this.iconWidth : iconRect.width
      this.iHeight = (this.iconHeight != null) ? this.iconHeight : iconRect.height
      if (this.iWidth === 0) {
            this.$nextTick(() => {
              this.adjustBounds(true)
              let timerID = setInterval(() => {
                if (this.iconSizeGet) {
                  clearInterval(timerID)
                } else {
                  this.adjustBounds(true)
                }
              },500)
          })
      } else {
        this.iconSizeGet = true
        this.$forceUpdate()
      }
      // if (debugOut) {
      //   if (this.contentszoom === "none") {
      //     console.log(`SVG: ${w} x ${h} ... iWidth = ${this.iWidth}, iconWidth = ${this.iconWidth}, iconRect.width = ${iconRect.width}`)
      //     console.log(`SVG:evticon = l${iconRect.left},t:${iconRect.top},w:${iconRect.width},h:${iconRect.height}  r:${iconRect.right},b:${iconRect.bottom}`)
      //   }
      // }
      return true
    },
    overColor(e) {
      this.frameColor = (this.frameStyle == 'transparent') ? 'rgba(255,255,255,0.2)' : this.defUIHighlightColor
    },
    leaveColor(e) {
      this.frameColor = (this.frameStyle == 'transparent') ? 'rgba(0,0,0,0)' : this.defUIFrameColor
      this.normalBack(e)
    },
    pushBack(e) {
      this.backColor = this.uiPushColor
    },
    normalBack(e) {
      this.backColor = this.defUIBackColor
    },
    changeDisable(p) {
      this.isDisable = p
      this.frameColor =
        (this.frameStyle == 'transparent')  ? "rgba(0,0,0,0)"
                                            : p ? this.defUIFrameDisColor
                                                : this.defUIFrameColor
      this.backColor = p ? this.defUIBackDisColor : this.defUIBackColor
    },
    mover(e) {
      if (this.isDisable || this.supportTouch) return
      this.overColor()
    },
    mleave(e) {
      if (this.isDisable || this.supportTouch) return
      this.leaveColor()
    },
    mdown(e) {
      if (this.isDisable || this.supportTouch) return
      this.pushBack()
    },
    mup(e) {
      if (this.isDisable || this.supportTouch) return
      this.normalBack()
    },
    tstart(e) {
      window.getSelection().removeAllRanges()
      if (this.isDisable || !this.supportTouch) return
      this.overColor()
      if (debugOut) {console.log('tstart!')}
    },
    tmove(e) {
      window.getSelection().removeAllRanges()
      if (this.isDisable || !this.supportTouch) return
      if (debugOut) {console.log('tmove!')}
    },
    tcancel(e) {
      window.getSelection().removeAllRanges()
      if (this.isDisable || !this.supportTouch) return
      this.leaveColor()
      if (debugOut) {console.log('tcancel!')}
    },
    tend(e) {
      window.getSelection().removeAllRanges()
      if (this.isDisable || !this.supportTouch) return
      this.leaveColor()
      if (debugOut) {console.log('tend!')}
    },
    fireEvent() {
      if (this.isDisable) return
      this.$emit("click")
    },
    igtstart () {
      return false
    },
  }
}
</script>

<style scoped>
#svgbtn {
  box-sizing: border-box;
  padding: 0;
  margin: 0;
}

.frameBoxSize {
  width: calc( 100% - 5px );
  height: calc( 100% - 5px );
}

.backBoxSize {
  width: calc( 100% - 1px );
  height: calc(100% - 1px);
}

</style>
